import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [CommonModule, RouterModule, ToastModule, TranslocoModule],
  templateUrl: './verify-email.component.html'
})
export class VerifyEmailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private translocoService = inject(TranslocoService);

  // State
  isLoading = signal(true);
  isSuccess = signal(false);
  errorMessage = signal('');

  async ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    
    if (!token) {
      this.handleError(this.translocoService.translate('emailVerification.messages.noToken'));
      return;
    }

    try {
      const response = await fetch(`${environment.apiUrl}/auth/verify-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        this.isSuccess.set(true);
        // Nettoyer localStorage si présent
        localStorage.removeItem('pendingVerificationEmail');
      } else {
        this.handleError(result.message || this.translocoService.translate('emailVerification.messages.verifyFailed'));
      }
    } catch (error) {
      // Capture critical email verification failure in Sentry
      Sentry.captureException(error, {
        tags: {
          'registration.failed_step': 'email_verify',
          'critical_error': 'true'
        },
        contexts: {
          verification: {
            token: token ? 'present' : 'missing',
            userAgent: navigator.userAgent
          }
        }
      });
      
      this.handleError(this.translocoService.translate('emailVerification.messages.connectionError'));
    } finally {
      this.isLoading.set(false);
    }
  }

  private handleError(message: string) {
    this.errorMessage.set(message);
    this.isSuccess.set(false);
    this.isLoading.set(false);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  goToRegister() {
    this.router.navigate(['/auth/register']);
  }
}